import { useCallback, useRef } from 'react';

export const useHouseFias = (
    houseFiasId: string,
    setHouseFiasId: (value: string) => void,
    isInternetSelected: boolean,
    fetchTechAbility: (fiasId: string) => void,
    reset: () => void,
) => {
    const houseFiasIdRef = useRef('');
    houseFiasIdRef.current = houseFiasId;

    const handleSelectAddress = useCallback((newHouseFiasId?: string | null) => {
        if (newHouseFiasId && newHouseFiasId !== houseFiasIdRef.current) {
            houseFiasIdRef.current = newHouseFiasId;
            setHouseFiasId(newHouseFiasId);

            if (isInternetSelected) {
                fetchTechAbility(newHouseFiasId);
            }
        }
        if (newHouseFiasId === null) {
            handleClearAddress();
        }
        
    }, [isInternetSelected, fetchTechAbility, setHouseFiasId]);

    const handleClearAddress = useCallback(() => {
        houseFiasIdRef.current = '';
        setHouseFiasId('');
        reset();
    }, [reset, setHouseFiasId]);

    const handleAddressValueChange = useCallback(() => {
        if (houseFiasIdRef.current) {
            houseFiasIdRef.current = '';
            setHouseFiasId('');
            reset();
        }
    }, [reset, setHouseFiasId]);

    return {
        handleSelectAddress,
        handleClearAddress,
        handleAddressValueChange,
    };
};
